import React, { useRef } from "react";
import config from "../../../contexts/ConfigContext";
import { DropDownListCustom, DropDownListCustomHandle } from "../../../components/DropDownlistCustom";
import { Row, Col } from "react-bootstrap";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';
import {
  GridColumnMenuProps,
  GridColumnMenuFilter  
} from "@progress/kendo-react-grid";
import { ODataProvider } from "../../../contexts/ODataContext";
import { LabelService, ParentModel } from "../../../services/LabelService";
import { DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import DataGridCustom, { ColumnCustomProps, DataGridHandle } from "../../../components/DataGridCustom";

import { Link, useLocation} from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { Button } from "@progress/kendo-react-buttons";
import { PermissionButton } from "../../../components/PermissionButton";
import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";

const ManageLabel: React.FC = () => {

  // Define properties and hooks
  const labelService = new LabelService();
  const { t } = useTranslation();
  const API_URL = config.API_URL;
  const searchList = {
    Label: t("general.search"),
    PlaceHolder: t("general.searchByTags"),
    TextField: "Description",
    KeyField: "LabelId",
    PageSize: 30,
    baseUrl: API_URL + "/odata/ProjectLabels?useCurrentFilter=false"
  }

  const location = useLocation();
  const { LabelId: ParentId, Description } = location.state as any;
  const labelApiUrl = config.API_URL + "/odata/ProjectLabels?useCurrentFilter=false";
  const [value, setValue] = React.useState<any>([]);
  const dataGridRef = useRef<DataGridHandle>(null);
  const searchTagRef = useRef<DropDownListCustomHandle>(null);
  const [selectedItems, setSelectedItems] = React.useState<number[]>([]);
  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);

  // Define the column menu
  const ColumnMenu = (props: GridColumnMenuProps) => {
    return (
      <div>
        <GridColumnMenuFilter {...props} expanded={true} />
      </div>
    );
  };

  const columns = [] as ColumnCustomProps[];
  columns.push({ field: "Description", title: t("general.name"), columnMenu: ColumnMenu, isExportable: true });
  columns.push({ field: "ParentDescription", title: t("general.parent"), columnMenu: ColumnMenu, isExportable: true });
  columns.push({ field: "Path", title: t("configuration.labels.path"), columnMenu: ColumnMenu, isExportable: true });
  columns.push({ field: "Tags", title: t("general.tags"), columnMenu: undefined, isExportable: true });
 
  const onSetValue = (event: DropDownListChangeEvent) => {
    setValue(event.target.value);
   
  }  

  const onSelectedItemsChange = (selectedItems: number[]) => {
    setSelectedItems(selectedItems);
  }

  const handleAddLabelLevel = () => {
    const parentModel: ParentModel = {
      LabelIds: [value.LabelId],
      ParentId: ParentId
    }
    labelService.SetParentLabel(parentModel).then(() => {
      dataGridRef.current?.refreshData();
    });
  }

  const handleRemoveLabelFromParent = () => {
    if (selectedItems.length > 0) {
      setShow(true);
    }
  }

  const handleConfirm = () => {
    setShow(false);
    const parentModel: ParentModel = {
      LabelIds: selectedItems,
      ParentId: 0
    }
    labelService.SetParentLabel(parentModel).then(() => {
      dataGridRef.current?.refreshData();
    });
  }

  React.useEffect(() => {

    searchTagRef.current?.setValueFilter({
      logic: "and",
      filters: [
        {
          field: "ParentId",
          operator: "eq",
          value: null
        }
      ]
    });
   
    dataGridRef.current?.filterData({
      logic: "and",
      filters: [
        {
          field: "ParentId",
          operator: "eq",
          value: ParentId
        }
      ]
    });   
  }, []);

  return (
    <div>
      <Row className="pt-2">
        <Col sm={{ span: 2, offset: 10 }}>
          <Link className="btn" to="/labels">
          <SvgIcon className="btn-icons" icon={svgIcons.arrowLeftIcon} size="medium" />
          <Trans>general.returnToBack</Trans></Link>
        </Col>
      </Row>
      <div className="pt-2">
        <div className="tile-content">
          <div>
        <h5 className="title"><Trans>general.manageLevelTo</Trans> {Description}</h5>
      </div>
      <Row className="pt-4">
        <Col sm={5} >        
          <ODataProvider baseUrl={searchList.baseUrl} loadingContent=".k-dropdownlist">
            <DropDownListCustom ref={searchTagRef} KeyField={searchList.KeyField} Label={searchList.Label} PageSize={searchList.PageSize} PlaceHolder={searchList.PlaceHolder} TextField={searchList.TextField} onChange={onSetValue} />
          </ODataProvider>
        </Col>
        <Col className="pt-4" sm={{span:2, offset:5}}>
        <PermissionButton code="configuration_labels_levels" mode="edit">
          <Button themeColor="primary" onClick={handleAddLabelLevel}><Trans>configuration.labels.addLabelsTo</Trans>{Description}</Button>
         </PermissionButton> 
        </Col>
      </Row>      
      </div>
      </div>
      <div className="pt-4">
        <div className="tile-content">
      <Row>
        <Col sm={12}>
          <ODataProvider baseUrl={labelApiUrl} loadingContent=".k-grid-content">
            <DataGridCustom PermissionButtonCode="configuration_labels_levels" ShowRemoveButton={true} onRemoveButtonClick={handleRemoveLabelFromParent} ref={dataGridRef} DataItemKey="LabelId" Columns={columns} onSelectedItemsChange={onSelectedItemsChange} />
          </ODataProvider>
        </Col>
      </Row>
      </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title><Trans>general.titleRemoveMessage</Trans></Modal.Title>
        </Modal.Header>
        <Modal.Body><Trans>general.removeMessage</Trans></Modal.Body>
        <Modal.Footer>
          <Button themeColor="secondary" onClick={handleClose}>
            <Trans>general.cancel</Trans>
          </Button>
          <Button themeColor="primary" onClick={handleConfirm}>
            <Trans>general.ok</Trans>
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ManageLabel;
